import { useQuery } from 'react-query';
import { getPlanUnitDetails } from 'RestAPIs/cost-centers';

const useGetPlanUnitDetails = (
  planUnitId?: number,
  referenceDate?: Date | null
) => {
  const { data, isFetching, isError, refetch } = useQuery(
    ['PlanUnitDetails', planUnitId, referenceDate],
    async () => {
      if (!planUnitId || !referenceDate) {
        return null;
      }

      const { data } = await getPlanUnitDetails({ planUnitId, referenceDate });
      return data;
    }
  );

  return { data, isFetching, isError, refetch };
};
export default useGetPlanUnitDetails;
